export const DEFAULT_LOCALE = import.meta.env.VITE_DEFAULT_LOCALE;
export const LOCALES = import.meta.env.VITE_LOCALES.split(/[,;]/);
